import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import {
  TablePagination,
  TableFooter,
  Button,
  Stack,
  Typography,
  TableBody,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  tableCellClasses,
  Alert,
  Menu,
  MenuItem,
  Card,
  CardHeader,
  IconButton,
  CardContent,
  FormControl,
  Select,
} from "@mui/material";
import Grid from "@material-ui/core/Grid";
import { useDispatch, useSelector } from "react-redux";
import { fetchMyInvitation, updateInviation } from "../../../paymentRequest";
import {
  showApiLoader,
  hideApiLoader,
  setUserLoginData,
} from "../../../../redux/tool-webjam/actions";
import { messages } from "../../../messages";
import { usePrevious } from "../../../Utils";
import { setPaymentInvitedRoom } from "../payment-reducer/actions";
import { paginationObject, SEARCH_DELAY_TIME, updateJammingCapability } from "../Utils";
import { FEATURE_CUSTOM_PAYMENT, FEATURE_CUSTOM_REDUX } from "../../../../constant";
import SearchInput from "../helperComponent/SearchInput";
import { Constant } from "../../../../../webjam/constant";
import { dateFormatter } from "../AbstractHelperComponent";
import { getBaseConfig, isMobileBrowserC, isSocialMobileApp } from "../../../../Utils";
import { updateUserJamStateReq } from "../../../Request.d";
import { Translate } from "../../../../../webjam/language";
import { JammingPreferenceSelect } from "./HostedRoom";
import { ct } from "../../../../constant-Utils";
import { socketEmit } from "../../../../../../../socket";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "var(--theme-primary-color)",
    color: theme.palette.common.white,
    fontSize: 16,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 16,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function InvitedRoom(props) {
  const [page, setPage] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const { userLoginData } = useSelector((store) => store[FEATURE_CUSTOM_REDUX]);
  const [pageNo, setPageNo] = useState({
    currentPage: 0,
    nextPage: 0,
    prevPage: 0,
  });

  const [totalRecord, setTotalRecord] = useState(0);
  const [recordPerPage, setRecordPerPage] = useState(10);
  const [list, setList] = useState([]);
  const dispatch = useDispatch();

  const [pageSearch, setPageSearch] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentActiveId, setCurrentActiveId] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setCurrentActiveId(event.currentTarget.id);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const isMobile = isMobileBrowserC();
  const open = Boolean(anchorEl);

  const { paymentInvitedRoom } = useSelector(
    (state) => state[FEATURE_CUSTOM_PAYMENT]
  );

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const { target } = event;
    setRecordPerPage(+target.value);
    setPage(0);
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Page change pagination
  const prevPage = usePrevious(page);
  useEffect(() => {
    let p = 0;
    if (prevPage != undefined && prevPage < page) {
      p = pageNo.nextPage;
    } else if (prevPage != undefined && prevPage > page) {
      p = pageNo.prevPage;
    }
    if (prevPage != undefined && p > 0 && !pageSearch) {
      fetchData("", "?page=" + p + "&limit=" + recordPerPage + "&isPagination=true");
    }
  }, [page]);

  const handleSearch = (e, isEmpty = false) => {
    setPageSearch(isEmpty ? "" : e?.target?.value);
  };
  let prevSearch = usePrevious(pageSearch);
  useEffect(() => {
    if (prevSearch != undefined) {
      setPage(0);
      var e = setTimeout(() => {
        const _pageSearch = pageSearch?.toLowerCase() || "";
        fetchData({}, "?page=0&limit=" + recordPerPage + "&isPagination=true&search=" + _pageSearch);
      }, SEARCH_DELAY_TIME);
      return () => clearTimeout(e);
    }
  }, [pageSearch]);

  const fetchData = (data = {}, pagination = "?page=1&limit=10&isPagination=true") => {
    setIsLoading(true);
    dispatch(showApiLoader());

    data = Object.assign(
      {
        search: pageSearch,
      },
      data
    );

    fetchMyInvitation(data, pagination)
      .then((res) => {
        if (res.status == 1) {
          let data = res.data.data;
          let pagination = res?.data?.pagination || paginationObject;
          if (!data?.length) {
            dispatch(
              setPaymentInvitedRoom({
                list: [],
                pagination: paginationObject,
              })
            );
            setTotalRecord(0);
            setRecordPerPage(10);
            setPageNo({
              currentPage: 0,
              nextPage: 0,
              prevPage: 0,
            });
            return false;
          }

          dispatch(
            setPaymentInvitedRoom({
              list: data,
              pagination: pagination
            })
          );
          setTotalRecord(pagination.count)
          setRecordPerPage(pagination.page.perPage)
          setPageNo(pagination.page)
        } else {
          dispatch(
            setPaymentInvitedRoom({
              list: [],
              pagination: paginationObject,
            })
          );
          setTotalRecord(0);
          setRecordPerPage(10);
          setPageNo({
            currentPage: 0,
            nextPage: 0,
            prevPage: 0,
          });
        }
      })
      .finally(() => {
        dispatch(hideApiLoader());
        setIsLoading(false);
      });
  };

  const handleRoomJoin = (id, groupName) => {
    // const socialUrl = Constant.App.socialUrl;
    // window.open(socialUrl+"/webcam/"+groupName,"_self");
    if (isSocialMobileApp()) {
      if (getBaseConfig("webViewApp")) { // For running project in web view application
        let socialReferrerUrl = getBaseConfig('appReferrerUrl')
        let refreshUrl = socialReferrerUrl + '/' + groupName;
        window.location.href = refreshUrl
      } else { // For running project in react native application
        socketEmit('mobile_room_start', {
          roomName: groupName,
          userId: userLoginData?.user?.id
        });
      }
      return false;
    } else {
      window.parent.location.href = getBaseConfig("socialReferrerUrl") + "/" + groupName;
    }

  };
  let _jammingInfo = userLoginData && userLoginData.jamming_capability_rooms || [];
  const [jammingInfo, setJammingInfo] = useState(_jammingInfo);

  const handleChangeJammingStatus = async (event, room_name) => {
    _jammingInfo = await updateJammingCapability(jammingInfo, room_name, event.target.value)
    dispatch(setUserLoginData({ ...userLoginData, jamming_capability_rooms: _jammingInfo }))
    setJammingInfo([..._jammingInfo]);
    fetchData();
  }

  if (isLoading) {
    return <>{ct("rta-trmc.waitLoading")}</>
  }

  return (
    <>
      {isMobile && <Menu
        id={"basic-popup"}
        autoFocus={false}
        anchorEl={anchorEl}
        open={open}
        className="root muiMenuWrapper"
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-popup",
        }}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem
          sx={{ paddingTop: "0px", paddingBottom: "0px" }}
          onClick={() => {
            const activeObj = paymentInvitedRoom.list.find(
              (r) => r?._id === currentActiveId
            );
            handleRoomJoin(activeObj._id, activeObj.groupName);
            handleClose();
          }}
        >
          <i className="fa fa-video-camera payment-theme-icon pointer theme-font-color"></i>
          <Typography>{ct("rta-trmc.dashboard.otherRoom.join")}</Typography>
        </MenuItem>
      </Menu>}
      <Grid
        container
        spacing={2}
        className="payment-hosted-room-list-container mb-2"
      >
        <Grid item xs={12} md={12} lg={12} sm={12}>
          <SearchInput
            pageSearch={pageSearch}
            handleSearch={handleSearch}
            classes={`pull-right ${isMobile ? "w-100" : ""}`}
            width={`100%`}
          />
        </Grid>
      </Grid>
      {!isMobile && <TableContainer>
        <Table id="invited-room-table" aria-label="customized table" stickyHeader>
          <TableHead>
            <TableRow>
              <StyledTableCell>{ct("rta-trmc.dashboard.otherRoom.roomName")}</StyledTableCell>
              <StyledTableCell>{ct("rta-trmc.dashboard.otherRoom.hostName")}</StyledTableCell>
              <StyledTableCell>{ct("rta-trmc.dashboard.otherRoom.startDate")}</StyledTableCell>
              <StyledTableCell className={isMobile ? 'stickyActionHeader' : ''}>
                {ct("rta-trmc.dashboard.otherRoom.action")}
              </StyledTableCell>
              {getBaseConfig("showJammingCapaility") &&
                <StyledTableCell>{ct("rta-trmc.dashboard.otherRoom.jammingCapability")}</StyledTableCell>
              }
            </TableRow>
          </TableHead>
          <TableBody>
            {!isLoading && !paymentInvitedRoom?.list?.length && (
              <StyledTableRow className="w-100">
                <StyledTableCell
                  colSpan={5}
                  style={{ textAlign: "-webkit-center" }}
                >
                  {ct("Translate.typography.noRecordFound")}
                </StyledTableCell>
              </StyledTableRow>
            )}
            {paymentInvitedRoom.list.map((row, i) => (
              <TableRow key={row?._id}>
                <StyledTableCell>
                  <Typography
                    sx={{
                      maxWidth: 200,
                      wordBreak: "break-word",
                    }}
                  >
                    {row.groupName || "-"}
                  </Typography>
                </StyledTableCell>
                <StyledTableCell>
                  <Typography
                    sx={{
                      maxWidth: 200,
                      wordBreak: "break-word",
                    }}
                  >
                    {row.userName || "-"}
                  </Typography>
                </StyledTableCell>
                <StyledTableCell>
                  {row.created_at
                    ? dateFormatter(row.created_at, "YYYY-MM-DD")
                    : "-"}
                </StyledTableCell>
                <StyledTableCell className={isMobile ? 'stickyActionColumn' : ''}>
                  {isMobile ? (
                    <i
                      id={row._id}
                      onClick={(e) => handleClick(e)}
                      className="fa fa-ellipsis-h pointer theme-font-color"
                      aria-hidden="true"
                    ></i>
                  ) : (
                    <Stack direction="row" spacing={2}>
                      {
                        <div className="joinBtnWrap">
                          <Button
                            id={`join-room-${i}`}
                            variant="contained"
                            className="p-theme-btn"
                            sx={{
                              fontSize: 14,
                            }}
                            onClick={() => handleRoomJoin(row._id, row.groupName)}
                          >
                            <i className="fa fa-video-camera payment-theme-icon"></i>
                            {ct("rta-trmc.dashboard.otherRoom.join")}
                          </Button>
                        </div>
                      }
                    </Stack>
                  )}
                </StyledTableCell>
                {getBaseConfig("showJammingCapaility") &&
                  <StyledTableCell>
                    <JammingPreferenceSelect row={row} jammingInfo={jammingInfo.length ? jammingInfo : _jammingInfo} handleChangeJammingStatus={handleChangeJammingStatus} />
                  </StyledTableCell>}
              </TableRow>
            ))}
          </TableBody>
          {!isMobile && paymentInvitedRoom?.list?.length > 0 ? <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={10}
                count={totalRecord}
                rowsPerPage={recordPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{
                  fontSize: 16
                }}
                SelectProps={{
                  MenuProps: { classes: { paper: "invite-pagination" } }
                }}
                className="invite-pagination"
              />
            </TableRow>
          </TableFooter> : null}
        </Table>
      </TableContainer>}

      {/* Mobile cards start here */}
      {isMobile && !isLoading && !paymentInvitedRoom?.list?.length && (<div className="w-100 text-center" style={{ fontSize: '16px' }}>{ct("rta-trmc.dashboard.otherRoom.noRecord")}</div>)}
      {isMobile && (paymentInvitedRoom?.list || []).map((row, i) => {
        return (<Card className="mb-5 custom-card-wrapper" key={row?._id}>
          <CardHeader
            sx={{ paddingBottom: "0px" }}
            className="headerCustomerOtherRoom"
            action={
              <IconButton aria-label="settings">
                <i
                  id={row?._id}
                  onClick={handleClick}
                  className="fa fa-ellipsis-h pointer theme-font-color"
                  aria-hidden="true"
                ></i>
              </IconButton>
            }
            title={<div className="d-flex"><span><b className="nameTitlewrapper">{ct("rta-trmc.dashboard.otherRoom.roomName")} : </b></span><span className="ml-2 NameContentWrapper">{row?.groupName || "-"}</span></div>}
          />
          <CardContent style={{ paddingTop: "0px" }}>

            <div className="d-flex"><Typography><b>{ct("rta-trmc.dashboard.otherRoom.hostName")} :</b></Typography><Typography className="ml-2">{row.userName || "N/A"}</Typography></div>
            <div className="d-flex"><Typography><b>{ct("rta-trmc.dashboard.otherRoom.startDate")} :</b></Typography><Typography className="ml-2">{row.created_at
              ? dateFormatter(row.created_at, "YYYY-MM-DD")
              : "N/A"}</Typography></div>
            {getBaseConfig("showJammingCapaility") &&
              <div className="mt-2"><Typography><b>{ct("rta-trmc.dashboard.otherRoom.jammingCapability")} :</b></Typography>
                <div className="ml-2">
                  <JammingPreferenceSelect row={row} jammingInfo={jammingInfo.length ? jammingInfo : _jammingInfo} handleChangeJammingStatus={handleChangeJammingStatus} />
                </div></div>}
            <div className="w-100 mt-2"><Button
              id={`join-room-${i}`}
              variant="contained"
              fullWidth
              size="small"
              startIcon={<i className="fa fa-video-camera"></i>}
              onClick={() => {
                handleRoomJoin(row._id, row.groupName);
              }}
              sx={{
                fontSize: 14,
                backgroundColor: "var(--theme-primary-color)",
              }}
              className="p-theme-btn"
            >{ct("rta-trmc.dashboard.otherRoom.joinRoom")}</Button></div>

          </CardContent>
        </Card>)
      })}
      {/* Mobile cards end here */}
      {isMobile && paymentInvitedRoom?.list?.length > 0 ? (<div className="mobile-pagination-wrapper">
        <TablePagination
          id="m-pagination"
          rowsPerPageOptions={[10]}
          count={totalRecord}
          rowsPerPage={recordPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{
            fontSize: 16,
          }}
          SelectProps={{
            MenuProps: { classes: { paper: "invite-pagination" } },
          }}
          className="welcome-pagination mobile-pagination"
        />
      </div>) : null}
    </>
  );
}

export default InvitedRoom; // Other rooms
